module.exports = __webpack_public_path__ + "img/coin.d748b142.png";